import { cn } from "@/lib/utils";

export const SUB_STATUS = {
  nouveau: { label: "Nouveau", cls: "bg-[#F5EFEB] text-[#581825] border-[#E5DEC9]" },
  rib_envoye: { label: "RIB envoyé", cls: "bg-amber-100 text-amber-900 border-amber-300" },
  actif: { label: "Actif", cls: "bg-emerald-100 text-emerald-900 border-emerald-300" },
  suspendu: { label: "Suspendu", cls: "bg-stone-200 text-stone-700 border-stone-300" },
  termine: { label: "Terminé", cls: "bg-neutral-200 text-neutral-700 border-neutral-300" },
};

export const PAYMENT_STATUS = {
  en_attente: { label: "En attente", cls: "bg-amber-100 text-amber-900 border-amber-300" },
  paye: { label: "Payé", cls: "bg-emerald-100 text-emerald-900 border-emerald-300" },
};

export const PREP_STATUS = {
  a_preparer: { label: "À préparer", cls: "bg-amber-100 text-amber-900 border-amber-300" },
  pret: { label: "Prêt", cls: "bg-emerald-100 text-emerald-900 border-emerald-300" },
  livre: { label: "Livré", cls: "bg-blue-100 text-blue-900 border-blue-300" },
  retire: { label: "Retiré", cls: "bg-purple-100 text-purple-900 border-purple-300" },
};

export const ORDER_PAYMENT = {
  pending: { label: "🟠 En attente", cls: "bg-amber-100 text-amber-900 border-amber-300" },
  paid: { label: "🟢 Payé", cls: "bg-emerald-100 text-emerald-900 border-emerald-300" },
  failed: { label: "🔴 Échoué", cls: "bg-red-100 text-red-900 border-red-300" },
  cancelled: { label: "⚪ Annulé", cls: "bg-stone-200 text-stone-700 border-stone-300" },
  refunded: { label: "🔵 Remboursé", cls: "bg-blue-100 text-blue-900 border-blue-300" },
};

export function StatusBadge({ type, value, testId }) {
  const map = type === "payment" ? PAYMENT_STATUS
    : type === "prep" ? PREP_STATUS
    : type === "order_payment" ? ORDER_PAYMENT
    : SUB_STATUS;
  const meta = map[value] || { label: value, cls: "bg-stone-100 text-stone-700 border-stone-300" };
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold border whitespace-nowrap",
        meta.cls
      )}
    >
      {meta.label}
    </span>
  );
}
